import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';
import { Button } from '@getsynapse/design-system';

import RenderNoRecords from 'Atoms/NoRecords/NoRecords';

import NoRequestsSvg from 'assets/icons/empty-requests.svg';
import { PATHS } from 'utils/constants';

type NoRequestsTableProps = {
  createNewRequestLink?: string;
  advancedIntake?: boolean;
};

const NoRequestsTable = ({
  createNewRequestLink = PATHS.REQUEST_PAGE,
  advancedIntake = false,
}: NoRequestsTableProps) => {
  return (
    <tr data-testid='no-requests-table'>
      <td colSpan={13}>
        <RenderNoRecords
          imageSrc={NoRequestsSvg}
          caption={intl.get('REQUESTS_LIST_PAGE.CREATE_MANAGE_REQUESTS')}
          className='h-empty-table-body'
        >
          {advancedIntake ? (
            <Button
              className='mt-2 mx-auto'
              onClick={() => {
                window.location.href = createNewRequestLink;
              }}
            >
              {intl.get('REQUESTS_LIST_PAGE.GET_STARTED')}
            </Button>
          ) : (
            <Link to={createNewRequestLink}>
              <Button className='mt-2 mx-auto'>
                {intl.get('REQUESTS_LIST_PAGE.GET_STARTED')}
              </Button>
            </Link>
          )}
        </RenderNoRecords>
      </td>
    </tr>
  );
};

export default NoRequestsTable;
